'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dGroup$002dCode$0024 from "./presto.types$-Group-Code$.js";
import * as $j_presto$002etypes$0024$002dSite$002dId$0024 from "./presto.types$-Site-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsView$$anon$65() {
  this.aI6 = null;
  this.aI4 = null;
  this.aI5 = false;
  this.aI2 = null;
  this.aI3 = false;
  this.aI7 = false;
  this.aI8 = false;
  this.aI6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_CredentialsView$$anon$65 as $c_Lpresto_CredentialsView$$anon$65 };
$p = $c_Lpresto_CredentialsView$$anon$65.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsView$$anon$65;
/** @constructor */
function $h_Lpresto_CredentialsView$$anon$65() {
}
export { $h_Lpresto_CredentialsView$$anon$65 as $h_Lpresto_CredentialsView$$anon$65 };
$h_Lpresto_CredentialsView$$anon$65.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.aI6;
});
$p.t = (function() {
  if ((!this.aI5)) {
    this.aI4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("site", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aI5 = true;
  }
  return this.aI4;
});
$p.ag = (function() {
  if ((!this.aI3)) {
    this.aI2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dSite$002dId$0024.$m_Lpresto_types$SiteId$().sQ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dCode$0024.$m_Lpresto_types$GroupCode$().k3(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aI3 = true;
  }
  return this.aI2;
});
$p.v = (function() {
  if ((!this.aI8)) {
    this.aI7 = false;
    this.aI8 = true;
  }
  return this.aI7;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_CredentialsView$$anon$65 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsView$$anon$65, "presto.CredentialsView$$anon$65", ({
  Ge: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_CredentialsView$$anon$65 as $d_Lpresto_CredentialsView$$anon$65 };
//# sourceMappingURL=presto.-Credentials-View$$anon$65.js.map
